<template>
  <div class="">
    <dl class="divide-y divide-gray-200">
      <template v-for="row in options" >
        <div v-bind:key="row.label" class="py-2 sm:py-3 sm:grid sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-500">
          {{row.label}}
          </dt>
          <dd class="mt-1 flex text-gray-900 sm:mt-0 sm:col-span-2">
            <span class="flex-grow">{{row.value}}</span>
          </dd>
        </div>
      </template>
    </dl>
  </div>
</template>
<script>
export default {
  name: 'info-field',
  data() {
    return {
      options: []
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
  },

  created() {
    this.getInfo();
    this.getRefresh()
  },
  methods: {
    async getInfo() {
      let config = {
        params: {
          ...this.$store.state.data,
          recordid: this.$route.params.record
        }
      }
      const response = await this.$http.get(this.field.uri, config)
      console.log(response.data)
      this.options = response.data
    },
    getRefresh: function(){
      this.intervalRefresh = setInterval(function () {
        this.getInfo();
      }.bind(this), 30000);
    }
  }
}
</script>
